import { render, staticRenderFns } from "./Constructor.vue?vue&type=template&id=3401036a&"
import script from "./Constructor.vue?vue&type=script&lang=ts&"
export * from "./Constructor.vue?vue&type=script&lang=ts&"
import style0 from "./Constructor.vue?vue&type=style&index=0&id=3401036a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports